<template>
  <!-- 隐私权限 -->
  <div>
    <div class="main">
      <div class="breadcrumb">
        <span>首页</span>
        <span>></span>
        <span>隐私条款</span>
      </div>
      <div class="main-content">
        <div class="content-l">
          <div class="privacy">
            <p>隐私条款</p>
            <div>
              《第一财经》杂志电子版（App应用）及浏览网站由上海第一财经传媒有限公司运营。注册和购买我们的产品，需要遵循《上海第一财经传媒有限公司隐私条款》。现将条款内容告知如下：
            </div>
            <div>
              【以下条款中，上海第一财经传媒有限公司（China Business
              Network）简称为CBN】
              <br />CBN隐私条款概要:
            </div>
            <div>
              1.简介
              <br />该部分界定了隐私条款所涉及的基本的CBN服务，同时概述了隐私条款的内容。
            </div>
            <div>
              2.信息提交和信息收集
              <br />该部分陈述了CBN从用户处收集的信息种类，以及非亲自确定的私人信息，是由CBN及第三方通过Cookies和相关技术完成的。
            </div>
            <div>
              3.通知和选择
              <br />该部分提供给用户对自己信息掌控的相关权利，包括：用户的信息是如何被收集和利用的，今后隐私条款变更我们将通过何种方式告知我们的用户，CBN服务数据保存的地方，以及链接到CBN服务的第三方网站。
            </div>
            <div>
              4.使用和公开
              <br />该部分阐述了我公司如何运用您的信息来提供和管理CBN的服务，包括我公司可能会对帮助我们提供服务的第三方公开您的资料。
            </div>
            <div>
              5.安全性
              <br />该部分描述了我公司的安全措施
            </div>
            <div>
              6.准入、修正以及合规性
              <br />该部分告知了用户如何进入以及更改由CBN保存的用户个人信息，以及如何注销他们的帐户。
            </div>
            <div>
              7.联系我们
              <br />1) 简介 <br />上海第一财经传媒有限公司运营着：
              <br />（a）《第一财经》杂志电子版（App应用）
              <br />（b）《第一财经》杂志电子版（应用商店应用）
              <br />（c）《单行本》电子版（App应用）
              <br />（e）第一财经网站以及所有与其相关联的网页、网站
              <br />（f）经由授权应用和网站提供的任何有关内容、标识、功能和其他信息及CBN服务，包括但不限于病毒、可嵌入式的或基于应用设备的技术（例如：应用软件、应用程序编程接口、插件等等），包括经由因特网，移动设备或其他装置（统称“服务”）。CBN的服务是基于中国新闻机构的一部分。
              <br />条款描述我们如何收集、使用和分享那些无法在CBN服务上公开的用户个人信息（例如：鉴定某个确定的人的信息，包括全名或电子邮箱地址）。条款同时介绍了通常我们如何处理非亲自确定信息（例如：个人兴趣、人口统计资料以及活动信息），使之与某用户或某账号相关联。该隐私条款适用于所有的“用户”，包括注册的及未注册的用户。
            </div>

            <div>
              2) 信息提交和信息收集
              <br />用户提交的信息
              <br />当您在使用或注册CBN服务时，我们会收集您的姓、名、用户名、电子邮箱地址、密码、头像图片、邮编（统称，“注册信息”）。如果您使用CBN服务分享内容或参与其他社交活动,我们会跟随您的活动情况，公开您的用户名/头像图片。
              <br />CBN服务收集的信息 <br />CBN服务活动信息
              <br />当您在使用CBN服务时，我们会适当收集一些非亲自确定信息。例如，为保证您能通过因特网连接到CBN的服务上，我们的服务器接收并记录您电脑和浏览器的信息，包括可能性的了解到您的IP地址，浏览器类型以及其他软硬件信息。如果您通过移动或其他设备进入CBN服务，我们同时也需要例如标识符、地理位置或其他交易信息等在内的设备信息。我们也会利用Cookies和其他追踪技术（包括浏览器Cookies、像素、beacons以及Adobe
              Flash技术Cookies），这些由少量数据组成的通常包括一个匿名的标识符的技术。当您首次进入一个网页并在电脑中保存时，网站会将您的数据发送到浏览器，网站据此可以获取信息。我们会用这些旧技术收集并储存关于您对CBN的使用，例如您浏览过的网页、搜索的问题以及您看过的广告。
              <br />支持（例如服务广告、允许用户分享内容或追踪网站使用总量统计等）CBN服务的第三方也会适用上述技术收集类似的信息。我们无法控制第三方技术，同时其适用也是由隐私条款监管的。
              <br />第三方机构
              <br />为帮助改善我们的服务，我们也会适时增补从其他用户、商业伙伴及其他公司等方面获取的信息。如果您是经由第三方登录或链接至CBN的服务，我们也会要求收集您在第三方服务时提供的公开用户ID，以及与其他服务（可用于与合作服务分享的）相关的公开信息。
              <br />3) 通知与选择 <br />通知和选择的途径
              <br />我们会首先通过该隐私条款通知您有关您个人信息收集和使用的相关通知。我们不会未经您同意，以悖于该隐私条款的方式，擅自使用您的个人信息。
              <br />隐私条款变更
              <br />我们会根据需要对该隐私条款进行相应变更。如果我们需要对您的个人信息有进一步的使用需求，我们会首先征得您的同意。
              <br />数据保存
              <br />CBN服务是基于中国的产品。如果您是中国境外用户，这表明您理解并同意您的个人信息会被传输至中国，并进行处理。由于美国数据保护法以及其他相关法律可能会与您所在国家的裁决略有不同，因此请您仔细阅读该隐私条款。
              <br />链接的网站
              <br />CBN服务也会被链接至其他子公司或第三方机构管理的产品服务，也会承担由第三方开发且维护的运营广告或者提供其他服务。我们不承担任何第三方机构隐私操作的责任，一旦您通过一个链接离开了CBN网站，进入一个第三方服务，或者点击了一个广告，您应该核对第三方机构适用的隐私条款。
              <br />4) 使用和公开 <br />通过CBN服务使用公开发布的信息
              <br />如果您使用CBN服务分享部分内容或者参与其他的社会活动，您的用户名，头像/图片以及所在地将会被公开，包括CBN服务上的其他用户，搜索引擎，广告商以及其他可以获取CBN服务的任何人。所有您在CBN服务上发布的内容及评论同时也会被公开（连同您的个人信息一同公开）
              <br />对信息的使用和公开
              <br />我们只有在确认您已经同意或者经过该隐私条款的授权，才会将您的非公开个人信息分享给非附属的第三方机构，而且我们只会将您的个人信息分享给附属公司。
              <br />我们会将从用户处收集的信息用于以下用途：
              <br />用于提供和管理CBN服务
              <br />我们将从用户处收集来的信息用于为用户提供CBN服务和相关功能，包括管理并改进某些服务和功能，通过发布相关内容、广告以及营销信息使用户体验个性化，提供客户支持同时回复用户疑问。为帮助实现这一举措，我们会对CBN服务上的活动使用进行相应调整或使用匿名数据，同时对该数据的使用并非针对该隐私条款。
              <br />向您发送邮件
              <br />CBN会定期向用户注册时提供的电子邮箱地址发送邮件（例如简讯简报），或者与CBN服务相关的通知。如果您想要终止接收相关的促销信息，您可以按照邮件下方的取消订阅的指示进行操作,或者是对服务内容进行设置。但有些例如CBN服务或政策的变更通知在内的一部分服务告知邮件一旦注册就不能退订。
              <br />允许第三方服务供应商帮助我们提供和管理CBN服务
              <br />我们可以将您的非公开个人信息提供给部分（提供服务支持的）第三方服务供应商，包括承包商、代理商或赞助商。以上服务供应商必须保护委托给他们的您的个人信息不被其他商业行为使用，而只用于特定在CBN服务上的产品服务。
              <br />保护我公司权益、保护用户
              <br />出于以下五个因素，同时基于良好声誉及法律要求，我们会事先通知用户，然后获取、保护以及公开用户信息：
              <br />（a）遵守法律及其程序 <br />（b）强化该协议
              <br />（c）回应有损第三方权益的内容或信息
              <br />（d）回应用户对技术服务或用户服务的要求
              <br />（e）保护（包括在紧急事件中）公司，用户或第三方机构的权益
              <br />（f）对非附属的第三方商业合作伙伴
              <br />如果你下载了一个我公司与生意合作伙伴合资的特许应用程序版本，或者是第一财经为生意伙伴所创造的仅供其所拥有的独资程序版本，我们会将您的个人信息或亲自确定的信息与合作方共享。
              <br />完成资产合并或者买卖
              <br />如果我们出售部分或全部业务、对资产进行转让、或者其它涉及到资产合并以及资产买卖的行为，我们会将您的用户信息作为交易的一部分传输给交易机构。
              <br />5) 安全
              <br />我们使用商业化的管理措施、技术措施等保障用户信息不丢失、不被未授权使用、不被泄露或更改。
              <br />6) 准入、修正以及合规性
              <br />您可以通过进行帐户设置，随时获取或者变更您的注册信息。您可以通过删除应用程序，或者根据以下方式联系我们，注销您的帐户。请注意，即时注销了您的帐户，部分与您帐户相关的信息备份（包括公开的评论及其他您已经发布在CBN服务上或者其它经由CBN服务的应用），仍然会在某些情况下被浏览。在欺诈鉴定和公司内部安全性合规检查之前，我们也会短期内在服务器上为您保留与您账户相关的补充信息。根据超高速缓存技术，您公开的帐户信息可能不会立即取消进入许可，同时也可能在其它搜索引擎及因特网上暂时保留。
              <br />7) 联系我们
              <br />如果您对该隐私条款仍有疑问，请通过以下方式联系我们：
              <br />Support Email Address: zzhoukankf@cbnweek.com
            </div>
          </div>
        </div>
        <div class="content-r">
          <Wechart></Wechart>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Wechart from "@/components/wechart";
import { getTdkList} from "@/api/tdk";
export default {
  components: {
    Wechart
  },
  data() {
    return {};
  },
  created() {
    getTdkList({column:0}).then(res => {
      console.log(res)
      const head = document.getElementsByTagName('head')
      const meta = document.createElement('meta')
      document.title= res.data.data[0].title;
      document.querySelector('meta[name="keywords"]').setAttribute('content',res.data.data[0].keyword)
      document.querySelector('meta[name="description"]').setAttribute('content', res.data.data[0].describe)
      head[0].appendChild(meta)
    })
  }
};
</script>
<style lang="scss" scoped>
.breadcrumb {
  color: #999999;
  font-size: 14px;
  line-height: 20px;
  padding-top: 20px;
  padding-bottom: 16px;
  span:last-child {
    color: #0091ff;
  }
}
.privacy {
  padding: 30px;
  background: #ffffff;
  margin-bottom: 60px;
  p {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  div {
    font-size: 18px;
    line-height: 36px;
    margin-bottom: 40px;
  }
  div:last-child {
    margin-bottom: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/privacy.vue